import { previewableImageContentTypes } from '../config/file-preview.config';

export function isPreviewableImage(file: { contentType?: string | null }): boolean {
  return previewableImageContentTypes.has((file.contentType ?? '').toLowerCase());
}
